<style lang="stylus" scoped>
    .share-content
        width 100%
    .share-icon
        text-align center
        padding-left 10px
        width 50px
        height 50px
        line-height 50px

    .moon-weixin
        color #56C13D

    .moon-weibo
        color #E91E34

    .moon-qzone
        color #FDC03C

    .moon-tweibo
        color #24A6DC

    .moon
        cursor pointer

    .flex
        display flex
        width 100%

    .text-small
        font-size 12px

    .text-normal
        font-size 16px

    .text-medium
        font-size 18px

    .text-large
        font-size 28px

    .text-huge
        font-size 48px

    .qr-title
        font-size 12pt
        padding 5px
        text-align center

    .share-target
        flex-grow 1
        text-align center
</style>

<style lang="stylus">
    .modal-qrcode > .modal-dialog
        width 230px !important
        margin-top 130px !important
        .qr-title
            text-align center
            padding 15px 0 0

    .modal-qrcode > .modal-header
        font-size 12pt
</style>

<template>
    <div style="width:100%">
        <div class="share-content bg-white pb1">
            <div class="p1" v-if="showTitle">
                {{title}}
            </div>
            <div class="flex">
                <div v-for="share in icons" class="share-target">
                    <div class="share-icon" @click="config($index)"><i class="moon" :class="[share.icon, fontSize]"></i>
                    </div>
                </div>
                <div class="share-icon add-more" v-if="hasMore"><i class="fa fa-plus"></i></div>
            </div>
        </div>
        <modal :visible.sync="visible" class="modal-qrcode">
            <div slot="header" class="qr-title">分享二维码，邀请好友来注册</div>
            <img :src="qrcode">
            <div slot="footer"></div>
        </modal>
    </div>
</template>

<script lang="babel">
    /**
     * Created by zhangjingguo on 16/9/9.
     * 分享的组件
     */
    import wx from 'weixin-js-sdk'
    import { user, company, env } from 'bootsets/runtime'
    import { modal } from 'bootsets/components'
    export default{
        name: 'share',
        components: { modal },
        props: {
            icons: {
                type: Array,
                default() {
                    return [
                        {
                            icon: 'moon-weixin',
                            type: 'weixin',
                        },
                        {
                            icon: 'moon-weibo',
                            type: 'weibo',
                            url: 'http://service.weibo.com/share/share.php'
                        },
                        {
                            icon: 'moon-qzone',
                            type: 'qzone',
                            url: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey'
                        },
                        {
                            icon: 'moon-tweibo',
                            type: 'qweibo',
                            url: 'http://v.t.qq.com/share/share.php?'
                        }
                    ]
                }
            },
            showTitle: {
                type: Boolean,
                default: true
            },
            content: Object,//分享内容 需要 title img desc url appKey
            size: {
                type: String,
                default: 'huge'
            },
            wxConfig: {
                type: Object,
            },
            title: {
                type: String,
                default: '分享到 : '
            },
            hasMore: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                visible: false
            }
        },
        computed: {
            fontSize() {
                switch (this.size) {
                case 'small':
                    return 'text-small'
                case 'normal' :
                    return 'text-normal'
                case 'medium' :
                    return 'text-medium'
                case 'large' :
                    return 'text-large'
                case 'huge':
                    return 'text-huge'
                }
            },
            qrcode() {
                return `${env.root}frame/open/qrcode?url=${this.content.url}`
            }
        },
        methods: {
            config($index) {
                const _share = this.icons[ $index ], _content = this.content, _config = {
                    title: _content.title || '',
                    url: _content.url || '',
                    img: _content.img || '',
                    pic: _content.img || ''
                }
                if (_share.type !== 'weixin') {
                    if (_share.type === 'weibo') {
                        _config.appKey = _content.appKey || ''
                    }
                    window.open(this.addUrlParams(_share.url, _config, true))
                } else {
                    this.configWx()
                }
            },
            addUrlParams(url, params, encode) {
                let key_name, add
                if (url.indexOf('?') != -1) {
                    add = ''
                } else {
                    add = '?'
                }
                for (key_name in params) {
                    if (params.hasOwnProperty(key_name)) {
                        add += ('&' + key_name + '=' + (encode ? encodeURIComponent(params[ key_name ]) : params[ key_name ]))
                    }
                }
                return (url + add).replace('?&', '?')
            },
            configWx() {
                this.visible = true
            },
            closeModal() {
                this.visible = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// share.vue?684febe5